<template>
     <a-spin :spinning="spinning">
        <!-- {{menus}}
        </hr> -->
        <a-drawer title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">
            <div v-if="formType == 'editMenu' || formType == 'addMenu'">
                <h6 class="heading-small text-muted mb-4">Main Menu</h6>  
                <form>
                    <base-input alternative="" label="Name" placeholder="" v-model="selectedMenu.mainMenu" input-classes="form-control"/>
                    <base-input alternative="" label="Component ID" placeholder="" v-model="selectedMenu.id" input-classes="form-control"/>
                    <base-input alternative="" label="Shortcut Key" placeholder="">
                        <a-select style="width: 100%" placeholder="Please select a function key" optionFilterProp="children"  v-model="selectedMenu.shortcutKey">
                              <a-select-option v-for="functionKey in (menuKeys.filter(n => !takenMenuKeys.includes(n)))" :key="functionKey" :value="functionKey">{{functionKey}}</a-select-option>
                        </a-select>
                    </base-input>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button v-if="formType == 'editMenu'" class="btn btn-success" @click.prevent="updateMenu">Save</button>
                        <button v-else class="btn btn-success" @click.prevent="createMenu">Create</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </form>
            </div>
            <div v-else>
                <h6 class="heading-small text-muted mb-4">Sub-Menu</h6>  
                <form>
                    <base-input alternative="" label="Name" placeholder="" v-model="selectedMenu.subMenu" input-classes="form-control"/>
                    <base-input alternative="" label="Component ID" placeholder="" v-model="selectedMenu.id" input-classes="form-control"/>
                    <!-- <base-input alternative="" label="Component ID" placeholder="" v-model="selectedMenu.id" input-classes="form-control"/> -->
                    <base-input alternative="" label="Action" placeholder="" v-model="selectedMenu.action" input-classes="form-control"/>
                    <base-input alternative="" label="Parameters" placeholder="">
                        <a-select  mode="tags" v-model='selectedMenu.params' style="width: 100%;" placeholder='Please define parameters here' input-classes="form-control"></a-select>  
                    </base-input>
                    <base-input alternative="" label="Shortcut Key" placeholder="">
                        <a-select style="width: 100%" placeholder="Please select a function key" optionFilterProp="children"  v-model="selectedMenu.shortcutKey">
                              <a-select-option v-for="functionKey in (subMenuKeys.filter(n => !takenSubMenuKeys.includes(n)))" :key="functionKey" :value="functionKey">{{functionKey}}</a-select-option>
                        </a-select>
                    </base-input>
                    <a-switch class="float-right" checked-children="Enabled" un-checked-children="Enabled" v-model="selectedMenu.isEnabled"/>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button v-if="formType == 'editSubMenu'" class="btn btn-success" @click.prevent="updateSubMenu">Save</button>
                        <button v-else class="btn btn-success" @click.prevent="createSubMenu">Create</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </form>
            </div>
        </a-drawer>

         <div class="" style="min-height: 100%">
           <div class="card-header border-0">
               <div class="row align-items-center">
                   <!-- <div class="col-md-12"> POS Menu Customization </div>
                   <div class="col-md-10"><small>Set how you want to display your POS Main Menu. You can drag the list to change order of presentation.</small></div> -->
                   <!-- <div class="col-md-2">
                       <base-dropdown class="nav-link pr-0 float-right" position="right">
                         <div class="media align-items-center" slot="title">
                           <i class="fa fa-ellipsis-v float-right btn-sm"></i>
                         </div>
                         <template>
                           <div class=" dropdown-header noti-title">
                             <h6 class="text-overflow m-0">ACTIONS</h6>
                           </div>
                           <div class="dropdown-item" >
                             <i class="fa fa-download"></i>
                             <span>Back to default</span>
                           </div>
                         </template>
                       </base-dropdown>
                   </div> -->
                   <div class="col-md-12"><br></div>
                   <div class="col-md-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                       
                       <div class="list-group list-group-flush">
                               <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                   <div class="row">
                                       <div class="col-md-4">MAIN MENU</div>
                                       <div class="col-md-8 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addMenu', selectedMenu, 0)">+ Add Menu</base-button></div>
                                   </div>
                               </div>
                        </div>
                       <draggable :key="draggableKey" :list="menus"  class="list-group" @start="dragging = true" @end="dragging = false" @click="alert('ok')">
                            <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(mainMenu, index) in menus" :key="mainMenu.id" :class="[{selected2: selectedMainMenu.id == mainMenu.id}]">
                                <div class="row" @click="setMainMenu(mainMenu)">
                                   <div class="col-md-8">
                                       <a-dropdown>
                                         <a class="ant-dropdown-link" href="#">
                                           <span class="fa fa-ellipsis-v"></span> 
                                         </a>
                                         <a-menu slot="overlay">
                                           <a-menu-item key=1 @click="showDrawer('editMenu', mainMenu, index)"> Edit - {{mainMenu.mainMenu}} </a-menu-item>
                                           <a-menu-item key=2 > 
                                             <a-popconfirm title="You are about to delete this menu?" okText="Delete" cancelText="Cancel" @confirm="deleteMenu(index)">
                                               Delete - {{mainMenu.mainMenu}}
                                             </a-popconfirm>
                                           </a-menu-item>
                                         </a-menu>
                                       </a-dropdown> &nbsp; 
                                       {{mainMenu.mainMenu}}
                                   </div>
                                   <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                </div>
                            </div>
                        </draggable>
                   </div>
                   <div class="col-md-6" style="padding:0px; border-right: 1px #E9ECEF solid; height: 600px;">
                       <div class="list-group list-group-flush">
                               <div class="list-group-item" style="font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                   <div class="row">
                                       <div class="col-md-4">SUB-MENU</div>
                                       <div class="col-md-8 float-right"><base-button class="float-right ml-1" type="primary" size="sm" @click="showDrawer('addSubMenu', selectedMenu, 0)">+ Add Menu</base-button></div>
                                   </div>
                               </div>
                        </div>
                       <draggable :key="draggableKey2" :list="selectedMainMenu.subMenu"  class="list-group" @start="dragging = true" @end="dragging = false">
                            <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(subMenu, index) in selectedMainMenu.subMenu" :key="subMenu.id">
                                <div class="row">
                                   <div class="col-md-8">
                                       <a-dropdown>
                                         <a class="ant-dropdown-link" href="#">
                                           <span class="fa fa-ellipsis-v"></span> 
                                         </a>
                                         <a-menu slot="overlay">
                                           <a-menu-item key=1 @click="showDrawer('editSubMenu', subMenu, index)"> Edit - {{subMenu.subMenu}} </a-menu-item>
                                           <a-menu-item key=2 > 
                                             <a-popconfirm title="You are about to delete this menu?" okText="Delete" cancelText="Cancel" @confirm="deleteSubMenu(index)">
                                               Delete - {{subMenu.subMenu}}
                                             </a-popconfirm>
                                           </a-menu-item>
                                         </a-menu>
                                       </a-dropdown> &nbsp; 
                                       {{subMenu.subMenu}}
                                   </div>
                                </div>
                            </div>
                        </draggable>

                   </div>

               </div>
           </div>
         </div>  
        </a-spin>
</template>

<script>

import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex'
var component_x;
export default {
    components: {
        draggable
    },
    data: function(){
            return {
                draggableKey2: 0,
                draggableKey: 0,
                menus: [],
                selectedMainMenu: 0,
                spinning: false,
                defaultMenus: [
                                    {   
                                        "mainMenu":"Operator",
                                        "id":"operator",
                                        "shortcutKey":"f3", 
                                        "subMenu":
                                        [
                                            {"subMenu":"Sign-On","id":"signOn","shortcutKey":"f3","action":"","params":""},
                                            {"subMenu":"Sign-Off","id":"signOff","shortcutKey":"f4","action":"signOff","params":""},
                                            {"subMenu":"Training","id":"training","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"End","id":"end","shortcutKey":"f6","action":"","params":""},
                                            {"subMenu":"POS Lock","id":"posLock","shortcutKey":"f7","action":"posLock","params":""},
                                            {"subMenu":"Media Counting","id":"mediaCounting","shortcutKey":"f8","action":"","params":""},
                                            {"subMenu":"Operator Declaration","id":"operatorDeclaration","shortcutKey":"f9","action":"operatorDeclaration","params":""},
                                            {"subMenu":"Shutdown","id":"shutdown","shortcutKey":"f10","action":"quitApp","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Sales",
                                        "id":"sales",
                                        "shortcutKey":"f4",
                                        "subMenu":
                                        [
                                            {"subMenu":"Price Inquiry","id":"priceInquiry","shortcutKey":"f3","action":"priceInquiry","params":""},
                                            {"subMenu":"Find Item","id":"findItem","shortcutKey":"f4","action":"itemLookup","params":""},
                                            {"subMenu":"No Sales","id":"noSale","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"Sell Gift Voucher","id":"sellGiftVoucher","shortcutKey":"f6","action":"","params":""},
                                            {"subMenu":"Salesman","id":"salesman","shortcutKey":"f7","action":"salesmanLookup","params":""},
                                            {"subMenu":"Delivery","id":"delivery","shortcutKey":"f8","action":"","params":""},
                                            {"subMenu":"Customer","id":"customer","shortcutKey":"f9","action":"customerLookup","params":""},
                                            {"subMenu":"Change Item Packaging","id":"changeItemPackaging","shortcutKey":"f10","action":"","params":""},
                                            {"subMenu":"Quantity","id":"changeQuantity","shortcutKey":"f11","action":"changeQuantity","params":"selectedProduct"}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Corrections",
                                        "id":"corrections",
                                        "shortcutKey":"f5",
                                        "subMenu":
                                        [
                                            {"subMenu":"Transaction Price Change","id":"transactionPriceChange","shortcutKey":"f3","action":"changeTransactionPrice","params":""},
                                            {"subMenu":"Line Void","id":"lineVoid","shortcutKey":"f4","action":"voidLine","params":""},
                                            {"subMenu":"Void All Items","id":"voidAllItems","shortcutKey":"f5","action":"voidAllItems","params":""},
                                            {"subMenu":"Price Change by Line","id":"priceChangeByLine","shortcutKey":"f6","action":"changeTransactionPrice","params":"lineNo"},
                                            {"subMenu":"Abort Receipt","id":"abortReceipt","shortcutKey":"f7","action":"abortReceipt","params":""},
                                            {"subMenu":"Receipt Void","id":"receiptVoid","shortcutKey":"f8","action":"receiptVoid","params":"transactionId"},
                                            {"subMenu":"Price Change by Item","id":"priceChangeByItem","shortcutKey":"f9","action":"","params":""},
                                            {"subMenu":"Item Return","id":"itemReturn","shortcutKey":"f10","action":"","params":""},
                                            {"subMenu":"Receipt Return","id":"receiptReturn","shortcutKey":"f11","action":"changeTransactionMode","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Payment",
                                        "id":"payment",
                                        "shortcutKey":"f6",
                                        "subMenu":
                                        [
                                            {"subMenu":"Total Cum Payment","id":"totalCumPayment","shortcutKey":"f3","action":"","params":""},
                                            {"subMenu":"Total","id":"total","shortcutKey":"f4","action":"","params":""},
                                            {"subMenu":"Cash","id":"cash","shortcutKey":"f5","action":"cashPayment","params":""},
                                            {"subMenu":"On Account Payment","id":"priceChangeByLine","shortcutKey":"f6","action":"","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Cash Management",
                                        "id":"cashManagement",
                                        "shortcutKey":"f7",
                                        "subMenu":
                                        [
                                            {"subMenu":"Pick Up","id":"pickUp","shortcutKey":"f3","action":"pickUp","params":""},
                                            {"subMenu":"Debit/Loan","id":"debitLoad","shortcutKey":"f4","action":"","params":""},
                                            {"subMenu":"Pay In","id":"payIn","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"Pay Out","id":"payOut","shortcutKey":"f6","action":"","params":""},
                                            {"subMenu":"On Account Payment","id":"onAccountPayment","shortcutKey":"f7","action":"","params":""},
                                            {"subMenu":"Cash Float","id":"cashFloat","shortcutKey":"f8","action":"cashFloat","params":""},
                                            {"subMenu":"E Pay","id":"ePay","shortcutKey":"f9","action":"","params":""},
                                            {"subMenu":"Ready To Eat","id":"readyToEat","shortcutKey":"f10","action":"","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Reports",
                                        "id":"reports",
                                        "shortcutKey":"f8",
                                        "subMenu":
                                        [
                                            {"subMenu":"Audit Trail","id":"auditTrailReport","shortcutKey":"f3","action":"auditTrailReport","params":""},
                                            {"subMenu":"E-Journal","id":"eJournalReport","shortcutKey":"f4","action":"eJournalReport","params":""},
                                            {"subMenu":"POS Report","id":"posReport","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"Returns Report","id":"returnsReport","shortcutKey":"f6","action":"voidReturnReport","params": ["R"] },
                                            {"subMenu":"Void Report","id":"voidReport","shortcutKey":"f7","action":"voidReturnReport","params": ["V"]},
                                            {"subMenu":"SC Sales Report","id":"scSalesReport","shortcutKey":"f8","action":"scPwdReport","params": ["S"]},
                                            {"subMenu":"PWD Sales Report","id":"pwdSalesReport","shortcutKey":"f9","action":"scPwdReport","params": ["D"]},
                                            {"subMenu":"Sales Report","id":"salesReport","shortcutKey":"f10","action":"salesReport","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Utilities",
                                        "id":"utilities",
                                        "shortcutKey":"f9",
                                        "subMenu":
                                        [
                                            {"subMenu":"Reason/Comment","id":"reasonComment","shortcutKey":"f3","action":"","params":""},
                                            {"subMenu":"Configure","id":"configure","shortcutKey":"f4","action":"","params":""},
                                            {"subMenu":"Synchronize","id":"synchronize","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"Force Full Synchronize","id":"forceFullSynchronize","shortcutKey":"f6","action":"forceFullSynchronize","params":""},
                                            {"subMenu":"Reconnect Web Services","id":"reconnectWebServices","shortcutKey":"f7","action":"","params":""},
                                            {"subMenu":"Resend Transactions","id":"resendTransactions","shortcutKey":"f8","action":"resendTransactions","params":""},
                                            {"subMenu":"Printer Diagnostics","id":"printerDiagnostics","shortcutKey":"f9","action":"healthChecker","params":""},
                                            {"subMenu":"Check E-Pay Host","id":"checkEPayHost","shortcutKey":"f10","action":"","params":""},
                                            {"subMenu":"Check IC Reader","id":"checkICReader","shortcutKey":"f11","action":"","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Transactions",
                                        "id":"transactions",
                                        "shortcutKey":"f10","subMenu":
                                        [
                                            {"subMenu":"Resume Transaction","id":"resumeTransaction","shortcutKey":"f3","action":"resumeTransactionLookup","params":""},
                                            {"subMenu":"Reprint Receipt","id":"reprintReceipt","shortcutKey":"f4","action":"reprintReceipt","params":""},
                                            {"subMenu":"Suspend Transaction","id":"suspendTransaction","shortcutKey":"f5","action":"suspendCurrentTransaction","params":""},
                                            {"subMenu":"Deposit In","id":"depositIn","shortcutKey":"f6","action":"","params":""},
                                            {"subMenu":"Deposit Out","id":"depositOut","shortcutKey":"f7","action":"","params":""},
                                            {"subMenu":"Deposit Void","id":"depositVoid","shortcutKey":"f8","action":"","params":""},
                                            {"subMenu":"Get Queue Order","id":"getQueueOrder","shortcutKey":"f9","action":"","params":""},
                                            {"subMenu":"Get PSS Order","id":"getPSSOrder","shortcutKey":"f10","action":"","params":""},
                                            {"subMenu":"Get E-Commerce Order","id":"getECommerceOrder","shortcutKey":"f11","action":"","params":""}
                                        ]
                                    },
                                    {
                                        "mainMenu":"Others",
                                        "id":"others",
                                        "shortcutKey":"f11",
                                        "subMenu":
                                        [
                                            {"subMenu":"Item Discount","id":"itemDiscount","shortcutKey":"f3","action":"itemDiscount","params":"selectedProduct"},
                                            {"subMenu":"Overall Discount","id":"overallDiscount","shortcutKey":"f4","action":"overallDiscount","params":""},
                                            {"subMenu":"Balance Inquiry","id":"balanceInquiry","shortcutKey":"f5","action":"","params":""},
                                            {"subMenu":"Retrieve Orders","id":"retrieveOrder","shortcutKey":"f6","action":"retrieveOrder","params":""}
                                        ]
                                    }
                            ],
                            drawerVisible: false,
                            formType: null,
                            selectedMenu: {},
                            takenMenuKeys: [],
                            takenSubMenuKeys: [],
                            subMenuKeys: ["f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "f10", "f11", "f12"],
                            menuKeys: ["f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8", "f9", "f10", "f11", "f12"],
                            index: 0,
                            settingCode: null,
            }
    },
    mounted: function() {
        // console.log("***************")
        // console.log(this.$attrs.defaultValue)
        component_x = this;
        this.spinning = true
        if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null)
            this.menus = this.$attrs.defaultValue
        else
            this.menus = this.defaultMenus

        this.settingCode = this.$attrs.settingCode
        // this.menus = this.defaultMenus
        this.menus.map(x => {
            this.takenMenuKeys.push(x.shortcutKey)    
        })
        this.spinning = false
    },
    watch: {
        menus: function(){
            var configValues = {}
            configValues[this.settingCode] = this.menus
            component_x.$emit("changeValue", configValues)
        }
    },
    methods: {
        setMainMenu(menu){
            this.selectedMainMenu =  menu;
            this.takenSubMenuKeys = [];
            if(menu.subMenu){
                menu.subMenu.map(x => {
                this.takenSubMenuKeys.push(x.shortcutKey)    
                })
            }
        },
        showDrawer(type, selected, index){
            this.drawerVisible = true;
            this.formType = type;
            this.selectedMenu = selected;
            this.index = index
        },
        onClose(){
            this.drawerVisible = false;
            this.formType = null;
            this.selectedMenu = {};
            this.index = 0;
        }, 
        validateMenu(){
            var s = this.selectedMenu
            if(_.isEmpty(s.mainMenu) || _.isEmpty(s.id) || _.isEmpty(s.shortcutKey)){
                return false;
            }else {
                return true;
            }
        },
        deleteMenu(index){
            this.menus.splice(index, 1)
            this.takenMenuKeys = []
            this.menus.map(x => {
                this.takenMenuKeys.push(x.shortcutKey)    
            })
            this.$notification['success']({
              message: 'Success',
              description: "Menu deleted successfully"
            });
        },
        updateMenu(){
            if(this.validateMenu()){
                this.menus[this.index] = this.selectedMenu
                this.takenMenuKeys = []
                this.menus.map(x => {
                    this.takenMenuKeys.push(x.shortcutKey)    
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Menu successfully updated"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            } 
        },
        createMenu(){
            if(this.validateMenu()){
                this.menus.push(this.selectedMenu)
                this.takenMenuKeys = []
                this.menus.map(x => {
                    this.takenMenuKeys.push(x.shortcutKey)    
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Menu successfully created"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            }
        },
        validateSubMenu(){
            var s = this.selectedMenu
            if(_.isEmpty(s.subMenu) || _.isEmpty(s.id) || _.isEmpty(s.shortcutKey)){
                return false;
            }else {
                return true;
            }
        },
        deleteSubMenu(index){
            this.selectedMainMenu.subMenu.splice(index, 1)
            this.takenSubMenuKeys = []
                this.selectedMainMenu.subMenu.map(x => {
                    this.takenSubMenuKeys.push(x.shortcutKey)    
                })
            this.$notification['success']({
              message: 'Success',
              description: "Sub-menu deleted successfully"
            });
        },
        updateSubMenu(){
            if(this.validateSubMenu()){
                // this.menus[this.index] = this.selectedMenu
                this.selectedMainMenu.subMenu[this.index] = this.selectedMenu
                this.takenSubMenuKeys = []
                this.selectedMainMenu.subMenu.map(x => {
                    this.takenSubMenuKeys.push(x.shortcutKey)    
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Sub-Menu successfully updated"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            } 
        },
        createSubMenu(){
            if(this.validateSubMenu()){
                if(this.selectedMainMenu.subMenu){
                    this.selectedMainMenu.subMenu.push(this.selectedMenu)
                }else{
                    this.selectedMainMenu.subMenu = []
                    this.selectedMainMenu.subMenu.push(this.selectedMenu)
                }
                // this.menus.push(this.selectedMenu)
                this.takenSubMenuKeys = []
                this.selectedMainMenu.subMenu.map(x => {
                    this.takenSubMenuKeys.push(x.shortcutKey)    
                })
                this.$notification['success']({
                  message: 'Success',
                  description: "Sub-Menu successfully created"
                });
                this.onClose()
            } else {
                this.$notification['error']({
                  message: 'Failed',
                  description: "Please check your inputs."
                });
            }
        }
    }
}
</script>

<style>
    .selected2{
        background-color:  #EFF6FF;
        color: #2371CC;
    }
</style>